import { useState } from "react";
import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import { Navigation, Pagination } from "swiper";
import "../supplier/SinglePartition.scss";
import SinglePartition from "../supplier/SinglePartition.jsx";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import amazing1 from "../../assets/images/amazing.png";
import sabad from "../../assets/images/sabad.png";
import plus from "../../assets/images/Icon feather-plus.png";
import sabadLog from "../../assets/images/logo-sabadi.png";

import SupplierContext from "context/SupplierContext";
import SingleProduct from "../supplier/SingleProduct.jsx";
import EditProductModal from "../supplier/EditProductModal";
import SinglePartitionNew from "components/supplier/singlePartitionNew";
import { AmazingSuggestion } from "components/supplier/SinglePartition.jsx";
export default function AmazingSuggest({ data }) {
  const { setProduct } = useContext(SupplierContext);

  return (
    // <div className="amazingStyles" style={{ backgroundColor: "#EF394E" }}>
    //   <Swiper
    //     dir="rtl"
    //     navigation={true}
    //     modules={[Navigation]}
    //     breakpoints={{
    //       1200: {
    //         slidesPerView: 5,
    //         spaceBetween: 20,
    //       },
    //       900: {
    //         slidesPerView: 4,
    //         spaceBetween: 20,
    //       },
    //       700: {
    //         slidesPerView: 3.5,
    //         spaceBetween: 20,
    //       },
    //       600: {
    //         slidesPerView: 3,
    //         spaceBetween: 10,
    //       },
    //       450: {
    //         slidesPerView: 2.5,
    //         spaceBetween: 10,
    //       },

    //       320: {
    //         slidesPerView: 2,
    //         spaceBetween: 10,
    //       },
    //     }}
    //     className="mySwiper SinglePartition"
    //   >
    //     <SwiperSlide>
    //       <div
    //         className="position-relative slide-one"
    //         style={{ width: "300px" }}
    //       >
    //         <img
    //           src={amazing1}
    //           className=" suggestion mx-5"
    //           style={{ width: "180px", marginTop: "40px", right: "100px" }}
    //         />
    //         <img
    //           className="sabad"
    //           src={sabad}
    //           style={{
    //             width: "300px",
    //             height: "300px",
    //             bottom: "0",
    //           }}
    //         />
    //       </div>
    //     </SwiperSlide>

    //     {data != undefined &&
    //       data.reverse().map((value, index) => {
    //         return (
    //           <SwiperSlide key={index}>
    //             <SinglePartitionNew
    //               value={value}
    //               setProduct={setProduct}
    //               index={index}
    //             ></SinglePartitionNew>
    //           </SwiperSlide>
    //         );
    //       })}
    //   </Swiper>
    // </div>

    <SinglePartition typeSection="amazing" data={data}></SinglePartition>
  );
}
